import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/ui/Loading";
import { fetchRelatedBlogs } from "../../features/relatedBlogs/relatedBlogsSlice";
import RelatedBlogListItem from "./RelatedBlogListItem";

export default function RelatedBlogList({ currentBlogId, tags }) {
    const dispatch = useDispatch();
    const { relatedBlogs, isLoading, isError, error } = useSelector((state) => state.relatedBlogs);

    useEffect(() => {
        dispatch(fetchRelatedBlogs({ tags, id: currentBlogId }));
    }, [dispatch, tags, currentBlogId]);

    // decide what to render
    let content = null;

    if (isLoading) content = <Loading />;
    if (!isLoading && isError) {
        content = <div className="col-span-12">{error}</div>;
    }
    if (!isLoading && !isError && relatedBlogs?.length === 0) {
        content = <div className="col-span-12">No related blogs found!</div>;
    }
    if (!isLoading && !isError && relatedBlogs?.length > 0) {
        content = relatedBlogs.map((blog) => (
            <RelatedBlogListItem key={blog.id} blog={blog} />
        ));
    }

    return (
        <>
            {content}
        </>
    );
}
